/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M14.846 14.4775a1.3961 1.3961 0 0 1-.0919.0839 1.3559 1.3559 0 0 1-.8663.313h-3.7082a1.0543 1.0543 0 0 1-1.054-1.054v-3.7081a1.3552 1.3552 0 0 1 .3969-.9583l8.0515-8.0515c1.47-1.47 3.8534-1.47 5.3235 0 1.47 1.47 1.47 3.8535 0 5.3235l-8.0515 8.0515Zm-4.2147-3.8619 2.7531 2.7531h-2.7531v-2.7531Zm4.0383 1.9089 7.1632-7.1632c.882-.882.882-2.312 0-3.194-.882-.8821-2.3121-.8821-3.1941 0l-7.1632 7.1631 3.1941 3.1941Zm-8.5034 3.947a.7529.7529 0 0 0-.7528-.7529H2.635c-1.4553 0-2.635 1.1797-2.635 2.635 0 1.4552 1.1797 2.635 2.635 2.635h14.6806a.7528.7528 0 1 1 0 1.5057H10.54a.7528.7528 0 1 0 0 1.5057h6.7756c1.2474 0 2.2586-1.0112 2.2586-2.2586 0-1.2473-1.0112-2.2585-2.2586-2.2585H2.635c-.6237 0-1.1293-.5056-1.1293-1.1293 0-.6237.5056-1.1293 1.1293-1.1293h2.7784a.7529.7529 0 0 0 .7528-.7528Z"
    clipRule="evenodd"
  />,
  'Scratch'
);
